import { apiCall, createQueryString } from "./../imports";
const PREFIX = "management/owners";

export default {
  getOwners(data) {
    return apiCall("get", `${PREFIX}${createQueryString(data)}`);
  },

  deleteOwners(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },

  addOwners(data) {
    return apiCall("post", `${PREFIX}/panel/create`, data);
  },
};
